export enum RuleTypeEnum {
  MIN = 'min',
  MAX = 'max',
  REQUIRED = 'required',
}
